<template>
  <div class="wrapper">
    <div class="header_wrapper">
      <v-toolbar color="primary" dark>
        <v-btn @click="routerBack" icon>
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-toolbar-title
          style="
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            margin: 0;
            padding: 0;
            max-width: 70%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          "
          class="text-center"
        >
          {{ childName }}
        </v-toolbar-title>
        <v-btn icon disabled style="visibility: hidden">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-toolbar>
    </div>

    <div class="pa-1" style="margin-top: 16px;">
      <v-select
        v-model="selectedNendo"
        @update:model-value="changeNendo"
        :items="nendoOptions"
        label="年度"
        variant="outlined"
        hide-details
        color="primary"
        base-color="primary"
        density="compact"></v-select>
    </div>

    <vue-loading
      loader="bars"
      v-if="fetchLoading"
      :active="fetchLoading"
      color="#EE6090"
      :size="{ width: '30px', height: '30px' }"></vue-loading>

    <v-list v-else density="compact">
      <!-- 1. key は template タグに移動し、v-list-item-group は削除 -->
      <template v-for="(i, index) in invoices" :key="i.year + index">
        
        <v-list-item @click="toDetail(i.oldOrder)">
          <!-- 2. 左側の画像: prepend スロット + v-avatar -->
          <template v-slot:prepend>
            <v-avatar class="ml-2">
              <v-img
                :src="
                  selectedChildImg
                    ? selectedChildImg
                    : 'https://via.placeholder.com/240x180?text=Sample+Image+1'
                "
              />
            </v-avatar>
          </template>

          <!-- 3. 中央のテキスト: v-list-item-title を直下に配置 -->
          <v-list-item-title>
            {{ createYearMonth({ year: i.year, month: i.month }) }}
          </v-list-item-title>

          <!-- 4. 右側のバッジ: append スロットを使用 -->
          <template v-slot:append>
            <div>
              <v-badge
                v-if="i.readDate === null"
                color="red"
                dot
                inline
              ></v-badge>
            </div>
          </template>
        </v-list-item>

        <v-divider />
      </template>
    </v-list>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

import { meModule } from '@/store/entityModules/me';
import { familyModule } from '@/store/entityModules/family';
import { invoiceModule } from '@/store/entityModules/invoice';

interface DataType {
  childId: number;
  childName: string;
  fetchLoading: boolean;
  selectedNendo: string;
}

export default defineComponent({
  components: {
    'vue-loading': Loading,
  },

  data: (): DataType => ({
    childId: NaN,
    childName: '',
    fetchLoading: true,
    selectedNendo: '',
  }),

  computed: {
    nendoOptions(): string[] {
      const nendoArray: string[] = [];
      let i = 0;
      const month = dayjs().format('MM');
      if (month === '01' || month === '02' || month === '03') {
        i++;
      }
      for (i; i < 6; i++) {
        const nendo = dayjs()
          .add(i * -1, 'year')
          .format('YYYY');
        nendoArray.push(nendo);
      }
      return nendoArray;
    },
    invoices() {
      const invoicesLocal: any[] = invoiceModule.invoices;
      const newOrderInvoices: any[] = [];
      for (var i = 0; i < invoicesLocal.length; i++) {
        if (invoicesLocal[i].month < 4) {
          invoicesLocal[i].oldOrder = i;
          newOrderInvoices.push(invoicesLocal[i]);
        }
      }
      for (var i = 0; i < invoicesLocal.length; i++) {
        if (invoicesLocal[i].month >= 4) {
          invoicesLocal[i].oldOrder = i;
          newOrderInvoices.push(invoicesLocal[i]);
        }
      }
      return newOrderInvoices;
    },
    selectedChildImg(): string | null {
      if (familyModule.family) {
        const children = familyModule.family.children;
        const child = children.find((c) => c.childId === this.childId);
        if (!!child) {
          return child.imageUrl;
        }
      }
      return null;
    },
  },

  methods: {
    routerBack() {
      this.$router.replace('/invoice/select');
    },
    toDetail(index: number) {
      invoiceModule.selectInvoice(invoiceModule.invoices[index]);
      this.$router.push({ name: 'InvoiceDetail' });
    },
    createYearMonth({ year, month }: { year: number; month: number }) {
      return `${year}年度${month}月`;
    },
    async changeNendo() {
      this.fetchLoading = true;
      await invoiceModule.fetchInvoices({
        childId: this.childId,
        year: Number(this.selectedNendo),
      });
      this.fetchLoading = false;
    },
  },

  async mounted() {
    this.selectedNendo = this.nendoOptions[0];
    if (typeof this.$route.query.childName === 'string') {
      this.childName = this.$route.query.childName;
    }
    if (typeof this.$route.query.childId === 'number') {
      this.childId = this.$route.query.childId;
      this.fetchLoading = true;
      await invoiceModule.fetchInvoices({ childId: this.childId, year: null });
      this.fetchLoading = false;
    }
    if (typeof this.$route.query.childId === 'string') {
      this.childId = Number(this.$route.query.childId);
      this.fetchLoading = true;
      await invoiceModule.fetchInvoices({ childId: this.childId, year: null });
      this.fetchLoading = false;
    }
    if (!this.childId || !this.childName) {
      this.$router.replace('/invoice/select');
    }
  },
});
</script>
<style lang="scss" scoped>
.wrapper {
  padding-top: calc(var(--app-top-offset) + 56px); // ← ヘッダー分
  margin-bottom: calc(env(safe-area-inset-bottom) + 56px);
}

/* ===== ヘッダー ===== */
.header_wrapper {
  height: 56px;
  width: 100%;
  position: fixed;
  top: var(--app-top-offset); // ← 超重要
  left: 0;
  z-index: 100;

  .outline {
    border: 1px solid rgb(var(--v-theme-primary));
  }
}

/* ===== フォーム余白 ===== */
.v-form {
  margin-top: 8px;
}

/* ===== ラベルサイズ ===== */
.label-size > .v-input__control > .v-input__slot > .v-input--selection-controls__input > label {
  font-size: 12px;
}
.content_wrapper {
  min-height: calc(100% - 56px);
  overflow-y: hidden;
}
</style>
